import { AxiosPost } from "../AxiosWrapper";
import { INITIALIZATION_SERVICE_URL } from "../../constants/ServiceUrls";

export const getTRClientDetails = () => {
  return AxiosPost(
    `${INITIALIZATION_SERVICE_URL}api/Client/GetTRClientDetails`
  );
};

export const updateTRClient = (clientDetails) => {
  return AxiosPost(`${INITIALIZATION_SERVICE_URL}api/Client/UpdateTRClient`, {
    clientDetails,
  });
};

export default {
  getTRClientDetails,
  updateTRClient,
};
